"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAspect = exports.GetErrorImage = exports.ErrorImage = exports.GetEmptyImage = exports.EmptyImage = exports.Site = exports.Platform = void 0;
var website_1 = require("utils/website");
var Platform;
(function (Platform) {
    Platform["WEB"] = "web";
    Platform["MWEB"] = "mweb";
})(Platform = exports.Platform || (exports.Platform = {}));
var Site;
(function (Site) {
    Site["LITB"] = "LITB";
    Site["MINI"] = "MINI";
    Site["OUKUU"] = "OUKUU";
})(Site = exports.Site || (exports.Site = {}));
exports.EmptyImage = (_a = {},
    _a[Site.LITB] = (_b = {},
        _b[Platform.WEB] = "https://i.ezbuy.sg/FluV4tzjHziGlXdVl45rNBLROybL",
        _b[Platform.MWEB] = "https://i.ezbuy.sg/FgAEgY5gvRxBHePwb0J__mv_R_rB",
        _b),
    _a[Site.OUKUU] = (_c = {},
        _c[Platform.WEB] = "https://i.ezbuy.sg/FnljguO715HZ7Onm-hwN-yA_dYOI",
        _c[Platform.MWEB] = "https://i.ezbuy.sg/FgAEgY5gvRxBHePwb0J__mv_R_rB",
        _c),
    _a);
exports.GetEmptyImage = function () {
    var platform = website_1.isPC() ? Platform.WEB : Platform.MWEB;
    var emptyImg = "";
    if (website_1.isLTOuku()) {
        emptyImg = exports.EmptyImage[Site.OUKUU][platform];
    }
    return emptyImg;
};
exports.ErrorImage = (_d = {},
    _d[Site.LITB] = (_e = {},
        _e[Platform.WEB] = "https://i.ezbuy.sg/FibTB_cZNkWsEG1AXLl4caVm6ydT",
        _e[Platform.MWEB] = "https://i.ezbuy.sg/FvoovYlN3YZAJP5zH40Y0t0sdf8K",
        _e),
    _d[Site.OUKUU] = (_f = {},
        _f[Platform.WEB] = "https://i.ezbuy.sg/FljZ8kY_W_zmFVjoj0r7t3YqOuzf",
        _f[Platform.MWEB] = "https://i.ezbuy.sg/FigVcm7WF-SkLab0ag-dbRNWDwz8",
        _f),
    _d);
exports.GetErrorImage = function () {
    var platform = website_1.isPC() ? Platform.WEB : Platform.MWEB;
    var errorImg = "";
    if (website_1.isLTOuku()) {
        errorImg = exports.ErrorImage[Site.OUKUU][platform];
    }
    return errorImg;
};
exports.formatAspect = function (side) {
    if (typeof side === "string" && isNaN(+side)) {
        return 0;
    }
    else if (!side) {
        return 0;
    }
    return +side;
};
